import React from "react"

const LeftIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
            <path d="M2 6.00003L17 5.99979" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6 0.999908L1.70711 5.2928C1.37377 5.62614 1.20711 5.7928 1.20711 5.99991C1.20711 6.20702 1.37377 6.37368 1.70711 6.70702L6 10.9999" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default LeftIcon